export default function getDocumentFormmated(document: string | undefined) {
    if (document === undefined) return '-'

    //retira os caracteres indesejados...
    var documentCleaned = document.replace(/[^\d]/g, "");

    if(documentCleaned.length === 11) {
        return documentCleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if(documentCleaned.length === 14) {
        return documentCleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    } else {
        return 'Não é documento';
    }
}


export const formatCep = (cep: string) => {
    return cep.replace(/(\d{5})(\d{3})/, '$1-$2'); 
}